import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';


const initialState = {
	isLoading: false,
	error: null,
	promocodes: [],
	promocode: null,
};

const slice = createSlice({
	name: 'promocode',
	initialState,
	reducers: {
		// START LOADING
		startLoading(state) {
			state.isLoading = true;
		},

		// HAS ERROR
		hasError(state, action) {
			state.isLoading = false;
			state.error = action.payload;
		},

		// GET PRODUCTS
		getPromocodesSuccess(state, action) {
			state.isLoading = false;
			state.promocodes = action.payload;
		},

	},
});


// ----------------------------------------------------------------------

// Reducer
export default slice.reducer;


/* export function getPromocodes() {
	return async (dispatch) => {
		dispatch(slice.actions.startLoading());
		try {
			// const response = await axios.get('/api/products');
			dispatch(slice.actions.getPromocodesSuccess(arr));
		} catch (error) {
			dispatch(slice.actions.hasError(error));
		}
	};
} */

export function getPromocodes(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/promocodes', {params: {id}});
      dispatch(slice.actions.getPromocodesSuccess(response.data.promocodes));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------